
export class WorkerSiteOwnerCompetency {
  id: number;
  expiryDate: Date;
  status: string;
  expired: boolean;
  competencyTypeId: number;
  competencyTypeLongName: string;
  competencyTypeShortName: string;
  name: string;
  files: { id: number, fileName: string }[];
  rejectionComments: string = '';
  siteOwnerId: number;
  siteOwnerName: string;
  siteOwnerRequiresToc: boolean;
  selected?: boolean;
  competencyCategory: string;

  public deserialize(input: any): this {
    this.id = input.id;
    this.expiryDate = input.expiryDate ? new Date(input.expiryDate) : null;
    this.status = input.status;
    this.competencyTypeId = input.competencyType.id;
    this.competencyTypeLongName = input.competencyType.value;
    this.competencyTypeShortName = input.competencyType.shortName;
    this.name = this.competencyTypeShortName ? this.competencyTypeShortName : this.competencyTypeLongName;
    this.competencyCategory = input.competencyCategory;
    this.rejectionComments = input.rejectionComments;
    this.siteOwnerId = input.siteOwnerUser.skylarkUserId;
    this.siteOwnerName = input.siteOwnerUser.name;
    this.siteOwnerRequiresToc = input.siteOwnerUser.allowTocAcknowledgement;
    this.expired = input.status === 'EXPIRED'; // TODO POWERSTATION is this needed. matches other competency model.
    this.selected = false;

    this.files = input.files.map(f => ({
      id: f.id,
      fileName: f.fileName,
    }));

    return this;
  }
};
